if(!('getSelection' in ShadowRoot.prototype)) {
    Object.defineProperty(ShadowRoot.prototype, "getSelection", {
        value() { return document.getSelection() }
    });
}